import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { CustomerService } from '../services/customer.service';
import { Customer } from '../../shared/models/customer.interface';
import { CustomerType } from '../../shared/models/customer.type.interface';
import { User } from '../../shared/models/user.interface';
import { CustomerFilter } from '../models/customer.filter';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

export interface DealerCustomerSummary {
  customerCount: number;
  salespersons: User[];
  customerTypes: CustomerType[];
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent extends AbstractBiditComponent {
  customers: Customer[];

  summary: DealerCustomerSummary;

  filter: CustomerFilter = { salespersonId: '', customerType: null } as CustomerFilter;
  canAddCustomer: boolean = false;
  canAddQuote: boolean = false;

  constructor(protected customerService: CustomerService, private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  init() {
    this.canAddCustomer = CustomerService.hasPermission(RolePermission.AddCustomer);
    this.canAddQuote = CustomerService.hasPermission(RolePermission.AddQuote);

    this.loadSummary();
  }

  loadSummary() {
    this.customerService.getSummary(this.filter)
      .subscribe({
        next: (data) => {
          this.summary = data;
        },
        error: (error: string) => this.errors = error
      });
  }
}
